// Server-authoritative snapshot path. As of P8-cleanup this is the ONLY path
// for online matches. The legacy peer-to-peer / host-resolver fallback has been
// retired and the ENABLE_AUTH_MATCH client opt-out is gone. The server-side
// ENABLE_AUTH_MATCH env var (rooms.js) remains the operational kill-switch:
// clients always speak the auth protocol; the server decides whether to serve
// snapshots. Kept as a function so the many call sites need no churn.
//
// Sandbox / solo mode IS an auth match too (Phase D2): it boots a real server
// solo instance where one pilot drives BOTH seats over the same pipeline.
// `props.isCasualSandbox` now only means "solo match" for renderer/seat-routing.
export function isAuthMatchEnabled() {
  return true;
}
